import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './data-table.css';

export class GroupDataTable extends Component {

  static propTypes = {
    configTable: PropTypes.object,
    onTableBinding: PropTypes.func,
    groupColumns: PropTypes.array,
    columns: PropTypes.array,
    items: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
  };
  constructor(props) {
    super(props);

    this.state = {
      isClassName: ''
    };
  }

  onSort(e, fieldName) {

    $('.cls-sort-icon').attr('class', 'glyphicon glyphicon-sort cls-sort-icon');

    var elm = $('#' + fieldName).parent();

    let order = $(elm).attr('data-order');

    if (order === 'ascending') {
      $('#' + fieldName).attr('class', 'glyphicon glyphicon-triangle-bottom cls-sort-icon');
      $(elm).attr('data-order', 'descending');
    } else {
      $('#' + fieldName).attr('class', 'glyphicon glyphicon-triangle-top cls-sort-icon');
      $(elm).attr('data-order', 'ascending');
    }
    const sortOrder = order === 'ascending' ? 'descending' : 'ascending';

    var config = {
      sort: { field: fieldName, order: sortOrder },
      page: { skip: 1, take: this.props.configTable.take }
    };

    this.props.onTableBinding(config);

  }

  onGroupTable(e, item, fn) {

    let elm = $(e.target);

    if (elm.hasClass('cls-open')) {
      elm.removeClass('cls-open');
      elm.removeClass(' fa fa-caret-down');
      elm.addClass('fa fa-caret-right ');
      $('#group-table-' + item.id).hide();
    } else {
      elm.addClass('cls-open');
      elm.removeClass('fa fa-caret-right ');
      elm.addClass(' fa fa-caret-down');
      $('#group-table-' + item.id).show();
    }

    if (fn) {fn(e, item);}
  }

  renderHeader = (item, index) => {
    let className = (item.className ? item.className : '');

    if (item.sort) {

      if (item.defaultSortOrder) {
        var sortIcon = item.defaultSortOrder === 'ascending' ? 'glyphicon glyphicon-triangle-top' : 'glyphicon glyphicon-triangle-bottom';

        return <th key={index} data-order={item.defaultSortOrder} onClick={(e) => {
          this.onSort(e, item.name);
        }} className={className + ' cls-sort'}>{item.title}
          <span id={item.name} className={sortIcon + ' cls-sort-icon'} />
        </th>;
      }

      return <th key={index} data-order='ascending' onClick={(e) => {
        this.onSort(e, item.name);
      }} className={className + ' cls-sort'}>{item.title}
        <span id={item.name} className='glyphicon glyphicon-sort cls-sort-icon' />
      </th>;
    }

    return <th key={index} className={className}>{item.title}</th>;
  }

  renderBody() {
    if (this.props.items.length > 0) {
      return this.props.items.map(this.renderRow);
    }

    return <tr key='no-data'><td><div className='no-items'>No Items</div></td></tr>;
  }

  renderRow = (item, _index) => {
    let domElm = <tr key={_index}>{this.props.columns.map((obj, index) => {
      if (obj.name === 'action') {
        return <td key={index} className={obj.className} style={{textAlign: obj.headerAlign}}>
          <a className={'cls-action ' + obj.icon} onClick={(e) => { obj.event(e, item); }} />
        </td>;
      }
      else {
        const dataValue = (item[obj.name] !== '' && item[obj.name] !== null) ? item[obj.name] : '-';
        if (obj.customRender) {
          return <td key={index} className={obj.className} style={{textAlign: obj.headerAlign}}>
            {(item[obj.name] !== '' && item[obj.name] !== null) ? obj.customRender(item) : '-'}
          </td>;
        }
        if (obj.onGroupTable) {
          let groupItems = (item['items'] ? item['items'] : {items: [] });

          let btnGroup = <i data-id={item.id} style={{ 'cursor': 'pointer' }} className='fa fa-caret-down cls-open' onClick={(e) => {
            this.onGroupTable(e, item, obj.onGroupTable);
          }} />;

          if (groupItems.items.length === 0) {btnGroup = <i> &nbsp;&nbsp; </i>;}

          return <td key={index} className={obj.className} style={{textAlign: obj.headerAlign}}>
            <div className='item'>{btnGroup} &nbsp;</div>
            <div className='tooltip1'>
              {/* <span className='txt'>{item[obj.name]}</span> */}
              <div className='tooltip-wrapper'>
                <span className='tooltiptext tooltip-bottom'>{dataValue}</span>
              </div>
            </div>
          </td>;
        }
        return <td key={index} className={obj.className} style={{textAlign: obj.headerAlign}}><div className='tooltip1'>
          <span className='txt'>{dataValue}</span>
        </div>
        </td>;
      }
    })}</tr>;

    return [domElm, this.renderGroup(item)];
  }

  renderGroup = (item) => {

    let groupItems = (item['items'] ? item['items'] : { items: [] });

    let colspan = this.props.groupColumns.length;

    let childrenDom = [];

    let me = this;
    groupItems.items.forEach((groupItem, index) => {
      childrenDom.push(<tr key={index}>
        {me.props.groupColumns.map((obj, _index) => {
          if (obj.name === 'action') {
            return <td key={_index} className='actionList' style={{textAlign: obj.headerAlign}}>
              <a className={'cls-action ' + obj.icon} onClick={(e) => { obj.event(e, groupItem); }} />
            </td>;
          } else {
            if (obj.customRender) {
              return <td key={_index} className={obj.className} style={{...obj.style, textAlign: obj.headerAlign}}>
                {(groupItem[obj.name] !== '' && groupItem[obj.name] !== null) ? obj.customRender(groupItem) : '-'}
              </td>;
            } else {
              return <td key={_index} className={obj.className} width={obj.width} style={{...obj.style, textAlign: obj.headerAlign}}>
                <span className='txt'>
                  {(groupItem[obj.name] !== '' && groupItem[obj.name] !== null) ? groupItem[obj.name] : '-'}</span>
              </td>;
            }
          }
        })}
      </tr>);
    });
    // $.each(groupItems.items, function(i, groupItem) {
    //   childrenDom.push(<tr>
    //     {me.props.groupColumns.map(obj => {
    //       if (obj.name === 'action') {
    //         return <td className='actionList'>
    //           <a className={'cls-action ' + obj.icon} onClick={(e) => { obj.event(e, groupItem); }} />
    //         </td>;
    //       } else {
    //         if (obj.customRender) {
    //           return <td className={obj.className}>{obj.customRender(groupItem)}</td>;
    //         } else {
    //           return <td className={obj.className} width={obj.width}>
    //             <span className='txt'>{groupItem[obj.name]}</span>
    //           </td>;
    //         }
    //       }
    //     })}
    //   </tr>);
    // });

    return <tr key='nested-table-row' id={'group-table-' + item.id} className={groupItems.items.length === 0 ? 'cls-display-none' : 'openTable'} itemID={item.id}>
      <td colSpan={colspan} className='tdCol'>
        <table className='table table-hover cls-table-group'>
          <tbody>
            {childrenDom}
          </tbody>
        </table>
      </td>
    </tr>;
  }

  render() {
    return <div className='cls-data-table' style={{backgroundColor: 'white'}}>
      <table className='table table-hover fs-table'>
        <thead>
          <tr className='cls-row'>
            {this.props.columns.map(this.renderHeader)}
          </tr>
        </thead>
        <tbody className='cls-tbody-simple-table'>
          {this.renderBody()}
        </tbody>
      </table>
    </div>;
  }

}




// WEBPACK FOOTER //
// ./src/components/data-table/group-data-table.js